export default __webpack_public_path__ + "static/media/check.c6bcd7c7.svg";